export function StatusPill({ status, label, className = '' }) {
  const map = {
    valid: 'pill-valid',
    expiring_soon: 'pill-expiring',
    expired: 'pill-expired',
    scheduled: 'pill-info',
    completed: 'pill-valid',
    cancelled: 'pill-expired',
    no_show: 'pill-expired',
    active: 'pill-valid',
    inactive: 'pill-info',
    lead: 'pill-coral',
    deleted: 'pill-expired',
    new: 'pill-info',
    contacted: 'pill-info',
    eval_scheduled: 'pill-teal',
    converted: 'pill-valid',
    org_admin: 'pill-navy',
    therapist: 'pill-teal',
    virtual_ops_manager: 'pill-navy',
    super_admin: 'pill-coral',
    read_only_auditor: 'pill-info',
  };
  const cls = map[status] || 'pill-info';
  const display = (label || status || '').toString().replace(/_/g, ' ');
  return <span className={`pill ${cls} ${className}`}>{display}</span>;
}
